import React from 'react'

import i18n from 'translations'

export const StudentHome = [
  {
    name: i18n.t('dashboard:name'),
    component: React.lazy(() => import('../../modules/common/GeneralStudent/StudentHomeComponent')),
    path: '/ecommerce-student',
    guards: ['allowOnlyEcommerceStudent', 'allowOnlyLogged'],
  },
  {
    name: i18n.t('area-descriptions:evolution'),
    component: React.lazy(() => import('../../modules/ecommerceStudent/Evolution')),
    path: '/ecommerce-student/evolution',
    guards: ['allowOnlyEcommerceStudent', 'allowOnlyLogged'],
  },
  {
    name: i18n.t('blox-selection:settings'),
    component: React.lazy(() => import('../../modules/ecommerceStudent/profile/StudentProfile')),
    path: '/ecommerce-student/settings',
    guards: ['allowOnlyEcommerceStudent', 'allowOnlyLogged'],
  },
]
